import React from 'react'
import { Box, Typography } from '@mui/material'

import styles from './style.module.scss'

export default function Footer () {
  return (
    <Box component='footer' sx={{ px: 2, py: 2, backgroundColor: '#222', display: 'flex' }}>
      <Typography variant='body2' color='white' sx={{ flex: 1, my: 'auto' }}>
        {`© ${new Date().getFullYear()} Boa Nota`}
      </Typography>
      <Box sx={{ px: 2 }}>
        <Typography variant='body2' color='white' className={styles.powered}>
          Powered by <a href='https://indrema.com.br/'>Indrema</a>
        </Typography>
      </Box>
    </Box>
  )
}
